(function () {
  function init() {
    var body = document.querySelector('[data-pg-article]');
    var toc = document.querySelector('[data-pg-toc]');
    if (!body || !toc || toc.dataset.built === '1') return;
    var hs = body.querySelectorAll('h2');
    if (hs.length < 3) return;
    toc.dataset.built = '1';
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (i + 1) + '-' + h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      toc.appendChild(a);
    });
    toc.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
